import { Input } from "antd";
import { Plus, X } from "lucide-react";
import { nanoid } from "nanoid";
import { RESUME_SECTION_TYPES } from "../../../optimizeResume/editor/config";
import SectionCardShell from "../../../optimizeResume/editor/SectionCardShell";

const blankItem = () => ({
  id: `cert-${nanoid(6)}`,
  name: "",
  issuer: "",
  issueDate: "",
  expirationDate: "",
  credentialId: "",
  credentialUrl: "",
});

export default function Certifications({
  id,
  data,
  onChange,
  onDelete,
  allCollapsed,
}) {
  const items = data ?? [];

  const updateItem = (idx, patch) => {
    onChange(items.map((it, i) => (i === idx ? { ...it, ...patch } : it)));
  };

  const removeItem = (idx) => {
    onChange(items.filter((_, i) => i !== idx));
  };

  const addItem = () => {
    onChange([...items, blankItem()]);
  };

  return (
    <SectionCardShell
      id={id}
      type={RESUME_SECTION_TYPES.CERTIFICATIONS}
      data={data}
      onChange={onChange}
      onDelete={onDelete}
      allCollapsed={allCollapsed}
    >
      <div className="flex flex-col gap-4">
        {items.map((it, idx) => (
          <div
            key={it.id}
            className="border border-gray-200 rounded-lg p-3 bg-gray-50/40"
          >
            <div className="flex justify-between items-start mb-2">
              <p className="font-medium text-sm text-[#344054]">
                {it.name || `Certification #${idx + 1}`}
              </p>
              <button
                onClick={() => removeItem(idx)}
                className="text-gray-400 hover:text-red-600"
              >
                <X size={16} />
              </button>
            </div>
            <div className="grid grid-cols-2 gap-2">
              <Input
                placeholder="Name (e.g. AWS Solutions Architect, CFA Level 2)"
                value={it.name}
                onChange={(e) => updateItem(idx, { name: e.target.value })}
              />
              <Input
                placeholder="Issuer (e.g. AWS, ICAI, CFA Institute)"
                value={it.issuer}
                onChange={(e) => updateItem(idx, { issuer: e.target.value })}
              />
              <Input
                placeholder="Issue date (YYYY-MM)"
                value={it.issueDate}
                onChange={(e) => updateItem(idx, { issueDate: e.target.value })}
              />
              <Input
                placeholder="Expiration date (YYYY-MM, optional)"
                value={it.expirationDate}
                onChange={(e) =>
                  updateItem(idx, { expirationDate: e.target.value })
                }
              />
              <Input
                placeholder="Credential ID (optional)"
                value={it.credentialId}
                onChange={(e) =>
                  updateItem(idx, { credentialId: e.target.value })
                }
              />
              <Input
                placeholder="Credential URL (optional)"
                value={it.credentialUrl}
                onChange={(e) =>
                  updateItem(idx, { credentialUrl: e.target.value })
                }
              />
            </div>
          </div>
        ))}
        <button
          onClick={addItem}
          className="self-start flex items-center gap-1 text-sm text-blue-600 hover:text-blue-700"
        >
          <Plus size={14} /> Add certification
        </button>
      </div>
    </SectionCardShell>
  );
}
